<template>
  <div
    class="relative w-full flex items-center justify-between h-[80px] pl-5 pr-10 font-poppins rounded-[10px] bg-customBlue-100">
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center justify-start mobile:gap-2 tablet:gap-3 z-50 relative top-[40px]">
        <div
          class="rounded-full p-0.5 overflow-hidden mobile:w-20 mobile:h-20 tablet:w-[100px] tablet:h-[100px] shadow-[0px_4px_10px_0px_#00000040;] bg-white">
          <img :src="imageSrc" alt="Profile Picture" class="object-cover object-top w-full h-full rounded-full" />
        </div>
        <!-- delete button  -->
        <button v-if="!showEditForm && showImageRemove && !imageSrc.includes('default')" @click="removeImage"
          type="button"
          class="transform lg:hover:scale-[1.05] active:scale-[0.98] group flex justify-center items-center mobile:w-[25px] mobile:h-[25px] tablet:w-[30px] tablet:h-[30px] cursor-pointer rounded-full duration-300 transition-all border !border-orange-100 laptop:hover:!bg-orange-100 bg-orange-100 laptop:bg-white">
          <img src="../../assets/images/trash-icon-updated.png" alt="icon"
            class="laptop:group-hover:hidden laptop:block hidden mobile:w-[15px] tablet:w-[17px] object-contain transition-all duration-300">
          <img src="../../assets/images/trash-icon-white-updated.png" alt="icon"
            class="laptop:group-hover:block laptop:hidden block mobile:w-[15px] tablet:w-[17px] object-contain transition-all duration-300">
        </button>
        <div v-if="showEditForm && !showChangePasswordForm"
          class="transform lg:hover:scale-[1.05] active:scale-[0.98] group flex justify-center items-center mobile:w-[25px] mobile:h-[25px] tablet:w-[30px] tablet:h-[30px] cursor-pointer rounded-full duration-300 transition-all border !border-[#F8B134] laptop:hover:!bg-[#F8B134] bg-[#F8B134] laptop:bg-white">
          <img src="../../assets/images/edit-profile.svg" @click="triggerFileUpload"
            class="laptop:group-hover:hidden laptop:block hidden mobile:w-[15px] tablet:w-[18px] object-contain transition-all duration-300"
            alt="icon">
          <img src="../../assets/images/camera-icon.svg" @click="triggerFileUpload"
            class="laptop:group-hover:block laptop:hidden block mobile:w-[15px] tablet:w-[18px] object-contain transition-all duration-300"
            alt="icon">
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" class="hidden" />
        </div>
      </div>
      <!-- Buttons -->
      <div class="flex gap-3 z-50">
        <button v-if="!showEditForm && !showChangePasswordForm" @click="openEditForm"
          class="text-sm rounded-full mobile:px-3 py-1 mr-4 border-[1px] CustomYellowBtn">
          Edit Profile
        </button>

        <button v-if="true && showEditForm && !showChangePasswordForm" @click="openChangePasswordForm"
          class="text-sm rounded-full mobile:px-3 py-1 bg-customYellow-100 hover:shadow-[0px_4px_10px_0px_#00000040] cursor-pointer !hidden">
          Change Password
        </button>
      </div>  
    </div>
  </div>
  <div v-if="!showEditForm && !showChangePasswordForm && user">
    <div class="flex justify-end mt-3 mobile:mb-8 tablet:mb-16">
    </div>
    <div class="profile-modal-content customScrollbar !max-h-[330px] largeDesktop:!max-h-[600px] overflow-auto">
      <div class="w-full flex flex-col px-2.5 gap-[10px] largeDesktop:gap-[20px] font-poppins">
        <div>
          <h4 class="!no-underline m-0 mobile:text-[20px] tablet:text-[25px] font-medium text-gray-900">Hi, {{
            user.user.full_name }}</h4>
          <p class="!no-underline m-0 text-base text-gray-500 ">{{ user.user.email }}</p>
        </div>
        <div class="w-full flex flex-col gap-2">
          <div>
            <h6 class="m-0 text-sm font-semibold text-customBlue-100">Phone</h6>
            <p class="!no-underline m-0 text-base text-[#333333] ">{{ user.user.phone || '-' }}</p>
          </div>
        </div>
        <div class="w-full flex flex-col gap-2">
          <div>
            <h6 class="m-0 text-sm font-semibold text-customBlue-100">Address</h6>
            <p class="!no-underline m-0 text-base text-[#333333] ">
              {{ user.user.default_address || '' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <button @click="signoutClicked" type="button"
      class="py-[8px] px-[30px] font-poppins mt-8 mobile:mx-2 tablet:mx-3 text-[15px] rounded-full no-underline font-semibold CustomYellowBtn !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100">Sign
      Out</button>
  </div>

  <!-- Edit Profile Form -->
  <div v-if="showEditForm && !showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20">
      <div class="w-full flex flex-col gap-2 px-2.5 max-h-[300px] tablet:max-h-[none] overflow-y-auto customScrollbar">
        <div class="pt-1">
          <inputComponent label="First Name" ref="firstNameRef" v-model="first_name" name="firstName" required
            placeholder="Enter First Name" />
        </div>
        <div class="pt-1">
          <inputComponent label="Last Name" ref="lastNameRef" v-model="last_name" name="lastName" required
            placeholder="Enter Last Name" />
        </div>
        <div class="pt-1">
          <inputComponent label="Email" ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX" required
            error-message="Please enter a valid email address" placeholder="Enter Email" />
        </div>
        <div class="pt-1 flex gap-2 hidden">
          <div class="w-1/2">
            <inputComponent label="Year's of Experience" ref="yearsofexperienceRef" type="number"
              v-model="years_of_experience" name="yearsofexperience" placeholder="Enter Years Of Experience" class="" />
          </div>
          <div class="w-1/2">
            <inputComponent label="Phone Number" ref="phoneRef" v-model="phone" name="phone" required type="tel"
              mask="(###) ###-####" placeholder="Enter Number" error-message="Invalid phone number" />
          </div>
        </div>
      </div>
      <!-- <div class="mt-[30px] py-[30px] px-2.5 border-y border-[#EFEFEF]">
        <button type="button" class="group w-full h-[40px] flex items-center justify-center gap-2.5 font-days font-normal text-sm rounded-md shadow-[0px_0px_10px_-4px_#00000040;] text-customBlue-100 bg-white laptop:hover:!bg-customYellow-100 laptop:hover:text-white">
          Add Address
          <img src="../../assets/images/location-icon.svg" alt="icon" class="h-[24px] w-[24px] object-cover block laptop:group-hover:hidden">
          <img src="../../assets/images/location-icon-hover.svg" alt="icon" class="h-[24px] w-[24px] object-cover hidden laptop:group-hover:!block">
        </button>
      </div> -->
      <div class="mobile:pt-[20px] laptop:pt-0 mobile:px-2 tablet:px-4 font-poppins">
        <div class="flex items-center justify-center gap-3 pt-4 border-t border-[#efefef]">
          <button type="button" @click="backUserClicked"
            class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-[30px] text-sm font-medium rounded-full 
            !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100 CustomYellowBtn">Back</button>
          <button type="button" @click="updateUserClicked"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-[18px] text-sm font-medium rounded-full !border-[1px] !border-customBlue-100 laptop:hover:!text-white !bg-transparent !text-customBlue-100 CustomBlueBtn">Save
            Changes</button>
        </div>
      </div>
    </form>
  </div>

  <!-- Change Password Form -->
  <div v-if="showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20 px-2.5">
      <div class="w-full flex flex-col gap-2">
        <div>
          <label for="confirmPhoneNumber" class="block mb-1 text-sm font-medium text-gray-700">New
            Password: <span class="text-red-600">*</span></label>
          <inputComponent v-model="newPassword" ref="newPasswordRef" name="newPassword" type="password"
            :regex="$constants.PASSWORD_REGEX" required placeholder="Enter new password"
            errorClass="!text-customYellow-100" error-message="Minimum 8 characters with uppercase, number & symbol"
            length="20" customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div>
          <label for="confirmPhoneNumber" class="block mb-1 text-sm font-medium text-gray-700">Confirm New
            Password: <span class="text-red-600">*</span></label>
          <inputComponent v-model="confirmPassword" ref="confirmPasswordRef" name="confirmPassword" type="password"
            required :confirmWith="newPassword" placeholder="Enter confirm password" errorClass="!text-customYellow-100"
            error-message="Passwords do not match" length="20"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div class="flex items-center justify-center gap-3 pt-4 border-t border-gray-200">
          <button @click="cancelModalClicked" type="button"
            class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-[30px] text-sm rounded-[5px] !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100 CustomYellowBtn">Cancel</button>
          <button @click="changePasswordClick" type="button"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-[18px] text-sm rounded-[5px] !border-[1px] !bg-transparent !text-customBlue-100 CustomYellowBtn">Save
            Changes</button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import { ref } from 'vue'
import inputComponent from '../partialComponent/inputComponent.vue';
import showEyeIcon from '../../assets/images/eyeshowIcon.png';
import hideEyeIcon from '../../assets/images/eyehideIcon.png';
import defaultProfile from '../../assets/images/defaultprofile-img.svg';
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  components: {
    inputComponent
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    openModal: {

    },

    clickedCallback: {

    },
    userObject: {

    }
  },

  data() {
    return {
      // Visibility flags
      stripeStatus: true,
      // Input values

      email: null,
      phone: null,
      first_name: null,
      last_name: null,
      years_of_experience: null,
      // oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      // Icons
      showEyeIcon,
      hideEyeIcon,
      imageSrc: defaultProfile,
      imageFile: null,
      tags: [],
      language: [],
      selectedTags: [],
      selectedLanguage: [],
      showEditForm: false,
      showChangePasswordForm: false,
      user: JSON.parse(localStorage.getItem('user')) ?? null,

    };
  },

  computed: {
    ...mapGetters(["stripLogin", "updatedUser", "connectivityInitDetails", "stripDisconnect", "updatePasswordResponse"]),

    showImageRemove() {
      if (this.imageSrc == defaultProfile) {
        return false
      } else {
        return true
      }
    }
  },

  watch: {
    updatedUser: function () {
      if (this.showEditForm) {
        toast.success("Profile has been updated successfully.")
      }
      this.showEditForm = false
      this.user.user = this.updatedUser
      localStorage.setItem('user', JSON.stringify(this.user))
      this.setUser()
    },

    openModal: function () {
      this.showEditForm = false
      this.showChangePasswordForm = false
      this.imageFile = null
      this.setUser()
    },

    stripDisconnect: function () {
      this.user.user.is_stripe_connect = 0
    },

    stripLogin: function () {
      if (this.stripLogin.redirect_url.length > 0) {
        window.open(this.stripLogin.redirect_url, "_blank");
      }
    },

    updatePasswordResponse: function () {
      toast.success("Password updated successfully.");
      this.showChangePasswordForm = false
      this.showEditForm = true
    },


    connectivityInitDetails: function () {
      // if (this.connectivityInitDetails.redirect_url.length > 0) {
      //   window.open(this.connectivityInitDetails.redirect_url, '_blank');
      // }
    },

  },

  methods: {
    ...mapActions(["updateUser", "removeUserImage", "stripeDsiconnect", "getConnectivityInitDetails", "stripeLoginConnect", "updatePassword"]),

    cancelModalClicked() {
      this.showChangePasswordForm = false
      this.showEditForm = true
    },
    changePasswordClick() {
      const refsToValidate = [
        // this.$refs.oldPasswordRef,
        this.$refs.newPasswordRef,
        this.$refs.confirmPasswordRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }

      this.updatePassword({
        // old_pwd: this.oldPassword,
        password: this.newPassword
      })
    },
    disconnectStrip() {

      this.$dialog.show({
        title: "Are you sure you want to disconnect your Stripe account?",
        text: "Once disconnected, you will no longer receive any payouts from My Happy Home.",
        onConfirm: () => {
          this.stripeDsiconnect()
        },
      });

    },

    viewStrip() {
      this.stripeLoginConnect()
    },
    connectStrip() {
      this.getConnectivityInitDetails()

    },

    removeImage() {

      this.$dialog.show({
        title: "Remove Profile Picture",
        text: "Are you sure you want to remove your profile picture?",
        onConfirm: () => {
          this.removeUserImage({})
          // this.imageSrc = 'https://cdn4.vectorstock.com/i/1000x1000/96/43/avatar-photo-default-user-icon-picture-face-vector-48139643.jpg'
        },
      });
    },

    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.yearsofexperienceRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }
      this.updateCall()
    },

    updateUserClicked() {
      this.submitClicked()

    },
    updateCall() {
      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("phone", this.phone)
      formData.append("email", this.email)
      formData.append("years_of_experience", this.years_of_experience)
      formData.append("languages", JSON.stringify(this.selectedLanguage))
      formData.append("expertise", JSON.stringify(this.selectedTags))
      formData.append("timestamp", (new Date()).getTime())


      if (this.imageFile) {
        formData.append("profile_picture", this.imageFile)
      }

      this.updateUser(formData)
    },
    backUserClicked() {
      this.showEditForm = false
    },
    setUser() {
      this.user = this.userObject

      this.email = this.user.user.email ?? null
      this.phone = this.user.user.phone ?? null
      this.first_name = this.user.user.first_name ?? null
      this.last_name = this.user.user.last_name ?? null
      this.years_of_experience = this.user.user.years_of_experience ?? null
      this.imageSrc = this.user.user.profile_picture ?? defaultProfile

      this.selectedTags = (this.user.user.expertises ?? []).map(item => item.id);
      this.selectedLanguage = (this.user.user.languages ?? []).map(item => item.id);
    },
    signoutClicked() {
      if (this.clickedCallback) {
        this.clickedCallback('signout')
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Size check (5MB)
      const maxSizeMB = 10;
      if (file.size / 1024 / 1024 > maxSizeMB) {
        toast.error(`File size is too large. Max allowed is 10 MB.`);
        event.target.value = "";
        return;
      }

      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");

        let width = img.width;
        let height = img.height;
        const max = 1280;

        if (width > height && width > max) {
          height *= max / width;
          width = max;
        } else if (height > max) {
          width *= max / height;
          height = max;
        }

        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {

            this.imageFile = new File([blob], "profile.jpg", {
              type: "image/jpeg",
            });

            this.imageSrc = URL.createObjectURL(blob);
          },
          "image/jpeg",
          0.85
        );

        URL.revokeObjectURL(url);
      };

      img.src = url;
    },
    handleFileChanges(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Check file size
      const fileSizeMB = file.size / 1024 / 1024;
      if (fileSizeMB > 10) {
        toast.error(`File size is too large. Max allowed is 10 MB.`);
        this.$refs.fileInput.value = ''; // Reset input
        return;
      }

      this.imageFile = file;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(this.imageFile);
    },
    toggleTag(tag) {
      if (this.selectedTags.includes(tag.id)) {
        this.selectedTags = this.selectedTags.filter(t => t !== tag.id)
      } else {
        this.selectedTags.push(tag.id)
      }
    },
    toggleLang(lang) {
      if (this.selectedLanguage.includes(lang.id)) {
        this.selectedLanguage = this.selectedLanguage.filter(t => t !== lang.id)
      } else {
        this.selectedLanguage.push(lang.id)
      }
    },
    openEditForm() {
      this.showEditForm = true
    },
    openChangePasswordForm() {
      this.showChangePasswordForm = true
      // this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
    }
  },

};
</script>
